import React, { useEffect, useState } from "react"
import ContainerPage from "../../../components/ContainerPage/ContainerPage"
import PageTitle from "../../../components/PageTitle/PageTitle"
import { getTabs } from "./config"
import SideBar from "./SideBar/SideBar"
import { StorageGetItem, USER } from "../../../lib/storage"
import { useIsSupervisor } from "../../../hooks/user"


const Accounting = () => {
  const isSupervisor = useIsSupervisor()
  const [activeTab, setActiveTab] = useState('payments')
  const [userRole, setUserRole] = useState('')
  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setUserRole(result?.role)
    })

  }, [])


  return (
    <ContainerPage>
      <PageTitle title="Accounting" />
      <div className="flex flex-row justify-between">
        <SideBar setActiveTab={setActiveTab} activeTab={activeTab} userRole={userRole} isSupervisor={isSupervisor}/>
        <div className="flex-1 min-w-0 ml-6 p-4 bg-surface border border-divider shadow-custom rounded-2xl overflow-x-auto">
          {
            getTabs({ activeTab, userRole, isSupervisor })
          }
        </div>
      </div>
    </ContainerPage>
  )
}

export default Accounting